import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { TranslateStoreState, selectCurrentLanguage } from '../store';
import { map } from 'rxjs';
import { format } from 'date-fns';

export abstract class DatePipeBase {
  protected currentLanguage: string;

  constructor(
    protected translateStore: Store<TranslateStoreState>,
    protected translationService: TranslateService,
  ) {
    this.translateStore.select(selectCurrentLanguage).subscribe((language) => {
      this.currentLanguage = language;

      this.currentLanguage =
        this.currentLanguage === 'en-us' ? 'en' : this.currentLanguage;

      this.currentLanguage = this.currentLanguage || 'en';
    });
  }

  protected translateDate(date: Date, formattedDate: string) {
    const month = date.getMonth();
    const monthString = format(date, 'MMM');

    return this.translationService.get('ARC_MONTH_NAMES_SHORT').pipe(
      map((translatedMonths: string[]) => {
        const translatedDate = formattedDate.replace(
          monthString,
          translatedMonths[month],
        );

        return translatedDate;
      }),
    );
  }
}
